import { motion } from "framer-motion";
import { useLang } from "../../context/LanguageContext";
import { VeroButton } from "./VeroButton";

export const Reassurance = () => {
  const { t } = useLang();
  return (
    <section className="px-6 md:px-14 py-32 md:py-48 text-center" data-testid="reassurance-section">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      >
        <p className="font-serif text-3xl md:text-5xl text-white leading-tight">{t.reassurance.line1}</p>
        <p className="mt-3 font-serif italic text-xl md:text-3xl text-zinc-400">{t.reassurance.line2}</p>
        <div className="mt-14">
          <VeroButton text={t.reassurance.cta} to="/book" testId="reassurance-cta-btn" />
        </div>
      </motion.div>
    </section>
  );
};
